"use client"

const ogUpdate = (title, thumb) => {
    document.querySelectorAll("meta[property=og\\:image]")[0].setAttribute("content", thumb);
    document.querySelectorAll("meta[property=og\\:title]")[0].setAttribute("content", "فيجماوية | " + title);
    // document.querySelectorAll('meta[property=og\\:url]')[0].setAttribute('content', thumb)
}


// const truncateText = (str, maxLength = 100, suffix = "...") => {
const truncateText = (str, maxLength) => {
    if (!str) return "";
    return str.length > maxLength ? str.slice(0, maxLength) + '..' : str;
}

const mobileCheck = function () {
    if (typeof window !== "undefined") {
        let check = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        // (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
        console.log(check);
        return check;
    }
};


const showHideMenu = () => {
    let menu = document.getElementsByClassName('burgerMenu');
    let navMenu = document.getElementById('navMenu');
    menu[0].classList.contains('show') ? (menu[0].classList.remove('show', 'bi-x'), menu[0].classList.add('bi-list'), navMenu.style.right = `-100vw`) : (menu[0].classList.add('show', 'bi-x'), menu[0].classList.remove('bi-list'), navMenu.style.right = `0`);
    // console.log(menu[0].classList.contai)
}


const ScrollDetector = () => {
    if (typeof window !== "undefined") {
        let header = document.getElementById('header')
        let burgerMenu = document.getElementById('burgerMenu')

        console.log("gheade ");
        console.log(burgerMenu);

        if (typeof window !== "undefined") {
            window.addEventListener("mousewheel", function (event) {

                var lastScrollTop = 0;


                window.addEventListener("scroll", function (event) {
                    let st = document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
                    if (st > lastScrollTop) {
                        // downscroll code
                        console.log("down")
                        header.style.top = "-10vh";
                        burgerMenu.style.top = "-10vh";

                    } else if (st < lastScrollTop) {
                        // upscroll code
                        console.log("up")
                        header.style.top = 0;
                        burgerMenu.style.top = "2.5vh";
                    } // else was horizontal scroll
                    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
                    if (event.wheelDelta >= 0) {
                        console.log("up")
                        header.style.top = 0;
                        burgerMenu.style.top = "2.5vh";
                    } else {
                        console.log("down")
                        header.style.top = "-10vh";
                        burgerMenu.style.top = "-10vh";

                    }
                })
            });
        }
    }
}

const alerti = () => {
    alert("hi");
}

const selectGender = () => {
    let gender = document.getElementsByClassName('selectGender');
}

const showHidePass1 = (e) => {
    // let pass = document.getElementById('togglePassword1');
    let passInput = document.getElementById('password1');
    let icon = e.target;
    if (icon.classList.contains('bi-eye')) {
        icon.classList.remove('bi-eye');
        icon.classList.add('bi-eye-slash');
        passInput.type = "password";
    } else {
        icon.classList.remove('bi-eye-slash');
        icon.classList.add('bi-eye');
        passInput.type = "text";
    }
}
const showHidePass2 = (e) => {
    // let pass = document.getElementById('togglePassword2');
    let passInput = document.getElementById('password2');
    if (passInput) {
        let icon = e.target;
        if (icon.classList.contains('bi-eye')) {
            icon.classList.remove('bi-eye');
            icon.classList.add('bi-eye-slash');
            passInput.type = "text";
        } else {
            icon.classList.remove('bi-eye-slash');
            icon.classList.add('bi-eye');
            passInput.type = "password";
        }
    }
}

const formatArabicDate = (isoDate) => {
    const date = new Date(isoDate);
    const options = {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    };

    return new Intl.DateTimeFormat('ar-EG', options).format(date);
}



const getTodayDate = () => {
    const today = new Date();
    const yyyy = today.getUTCFullYear();
    const mm = String(today.getUTCMonth() + 1).padStart(2, '0');
    const dd = String(today.getUTCDate()).padStart(2, '0');

    const after = `${yyyy}-${mm}-${dd}T00:00:00`;
    const before = `${yyyy}-${mm}-${dd}T23:59:59`;

    return { after, before };
}


module.exports = {
    ogUpdate,
    // mobileCheck,
    // showHideMenu,
    showHidePass1,
    showHidePass2,
    // alerti,
    formatArabicDate,
    // ScrollDetector
    getTodayDate,
    truncateText
}

// export default ogUpdate;